import React from 'react'
import { PartialCoverdImage } from 'components/PartialCoverdImage'
import { ImageCredits } from 'components/ImageCredits'
import { Quote } from 'components/Quote'
import { PersonIntroduction } from 'components/PersonIntroduction'

export const Elina = ({
  size,
  colors
}: {
  size: { width: number; height: number; isMobile: boolean }
  colors: { main: string; sub: string; cover: string }
}) => (
  <div className='ui vertical segment'>
    <div className='ui text container'>
      <div className='ta text'>
        <PersonIntroduction
          name='Elina Falchi'
          sub={
            <>
              50, Pflegefachfrau, Zürich,
              <br /> seit 1999 in der Schweiz, Stimmrecht seit 2011
            </>
          }
          img={require('images/elina_quad.jpg')}
          colors={colors}
        />
        <p>
          «In meinem Heimatland konnte ich nie abstimmen. Ich wurde in
          Argentinien geboren, während der Militärdiktatur. Als Kind merkte ich
          nicht viel davon. Aber für die Erwachsenen war es schlimm, auch wenn
          sie abstimmen durften. Als ich 18 und somit stimmberechtigt wurde,
          tauchte mein Name fälschlicherweise nicht auf der Liste für
          registrierte Wählerinnen und Wähler auf. Kurz danach wanderte ich nach
          Italien aus.
        </p>
        <p>
          Wie es sich anfühlte, zum ersten Mal in der Schweiz abzustimmen? Sehen
          Sie, ich hatte auch vorher immer das Gefühl, als Frau respektiert zu
          werden. In der Familie, in der Ehe. Ich hatte immer eine Stimme, aber
          nicht in der Gesellschaft.
        </p>
      </div>

      <div className='ta text'>
        <Quote infos={'Elina Falchi '} colors={colors}>
         «Meine Tochter soll eine gleichberechtigte Beziehung führen können.»
        </Quote>
        <p>
          Je mehr Zeit ich in der Schweiz verbrachte, desto wichtiger wurde mir
          das Stimmrecht. Ich habe erlebt, wie sich Frauen oft an ihrem Mann
          orientiert haben, wenn sie abstimmten. Ich habe mich komplett von
          meinem Mann gelöst. Ich informiere mich und bilde mir meine eigene
          Meinung. Oft schicke ich meine Unterlagen bereits früh ab, während
          mein Mann bis zum letzten Tag überlegt.
        </p>
        <p>
          Zu wissen, dass man, egal was passiert, hier bleiben und
          Entscheidungen mitlenken kann, finde ich sehr besonders. Nun, da ich
          auf dem Papier Schweizerin bin, kann ich politisch offiziell sagen,
          was ich denke. Als ‹Ausländerin› konnte ich das nicht. Und hier ist
          alles so gut organisiert. Alle paar Monate kriegt man ein Couvert nach
          Hause geschickt, man darf selbst Initiativen einreichen. Das ist ein
          Luxus.
        </p>
      </div>
    </div>
    <div className='ui container '>
      <PartialCoverdImage
        url={size.isMobile ? 'elina_hoch.jpg' : 'elina_quer.jpg'}
        covers={['bottom left', 'top left']}
        colors={colors}
        infos={[
          size.isMobile ? 'bottom left' : 'bottom left',
          <ImageCredits
            noSpace
            text='Elina Falchi in ihrem Zuhause in Zürich. Ihr Quartier sieht sie als die perfekte Schweiz im Kleinen: ‹Multikulti.›'
            colors={colors}
          />
        ]}
      />
    </div>
    <div className='ui text container '>
      <div className='ta text'>
        <p>
          Ich habe mich immer für Frauenrechte und die Rechte von Ausländerinnen
          und Ausländern eingesetzt und lief an vielen Demos mit. Ich bin bei
          der Unia. Dort kämpfe ich für gerechtere Löhne und Arbeitsbedingungen
          – die würden vielen Frauen helfen.{' '}
        </p>
        <p>
          Besonders in Erinnerung geblieben ist mir die Abstimmung über die
          Minarettinitiative. Die Stimmung am Tag danach hat mich beeindruckt.
          Das Personal war still. Niemand hat gelacht, es wurde kaum gesprochen.
          Muslime und Nicht-Muslime. Ich sagte zu einem Kollegen: ‹Tut mir leid,
          wie es gelaufen ist.›{' '}
        </p>
        <p>
          Die Abstimmung über den Vaterschaftsurlaub dagegen hat mich gefreut.
          Meine zwei Kinder, besonders meine Tochter, sollen später davon
          profitieren und eine gleichberechtigte Beziehung führen können.»
        </p>
      </div>
    </div>
  </div>
)
